import ScalarIconBracketsCurly_vue_vue_type_script_setup_true_lang_default from "./ScalarIconBracketsCurly.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconBracketsCurly.vue
var ScalarIconBracketsCurly_default = ScalarIconBracketsCurly_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconBracketsCurly_default as default };

//# sourceMappingURL=ScalarIconBracketsCurly.js.map